<script>
export default {
  props: {
    title: {
      default: '小满设计装饰',
      type: String
    },
    evaluateAvg: {
      default: 4,
      type: Number
    }
  },
  methods: {
    onClickAsk() {
      this.$emit('onClickPromotionConnection')
    }
  }
}
</script>

<template>
  <div class="promotion_connection">
    <div class="promotion_connection_title">
      <strong class="font_weight_500">{{ title }}</strong>
    </div>
    <div v-show="evaluateAvg > 0" class="promotion_connection_star">
      <span>口碑:</span>
      <no-ssr>
        <star-rating
          :read-only="true"
          :show-rating="false"
          :rating="evaluateAvg"
          :star-size="2"
        />
      </no-ssr>
    </div>
    <div @click="onClickAsk" class="promotion_connection_button white_button">
      <strong class="font_weight_500">咨询商家</strong>
    </div>
  </div>
</template>

<style lang="scss">
.promotion_connection {
  display: flex;
  align-items: center;
  flex-direction: column;
  border: 1px solid rgba(239, 241, 242, 1);
  .promotion_connection_title {
    margin-top: 20px;
    font-size: 20px;
    font-weight: 500;
    color: rgba(68, 68, 68, 1);
    line-height: 20px;
  }
  .promotion_connection_star {
    font-size: 12px;
    font-weight: 400;
    color: rgba(68, 68, 68, 1);
    line-height: 12px;

    margin-top: 11px;
    margin-bottom: 10px;
  }
  .promotion_connection_button {
    width: 195px;
    height: 44px;
    margin-top: 10px;
    margin-bottom: 20px;
    font-size: 14px;
    font-weight: 400;
    color: rgba(68, 68, 68, 1);
    line-height: 14px;
  }
}
</style>
